import React from "react";
import { useParams } from "react-router-dom";
import { Contributor } from "../Contributor";
import "./style.css";
export const Viewer = ({ contributor, contributor_link }) => {
  const { id } = useParams();
  const src = `https://drive.google.com/file/d/${id}/preview`;
  return (
    <div className="viewer">
      <iframe src={src} className="preview-area"></iframe>
      {contributor && (
        <Contributor name={contributor} link={contributor_link} />
      )}
    </div>
  );
};
